import { useState } from 'react';
import { TabContext, TabPanel } from '@mui/lab';
import { Box, Button, Stack, Tab, Tabs, tabClasses, tabsClasses } from '@mui/material';
import { url } from 'config/config';
import { cssVarRgba } from 'lib/utils';
import { enqueueSnackbar } from 'notistack';
import FilePreview from 'components/SS/filePreview';

const CandidateDocuments = ({ state }) => {
  const [value, setValue] = useState('resume');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = () => {
    try {
      const files = [
        { url: `${url}${state.resume}`, name: 'resume' },
        { url: `${url}${state.aadharCard}`, name: 'aadhar-card' },
        { url: `${url}${state.degreeCertificate}`, name: 'degree-certificate' },
      ];

      (state.document1 && files.push({ url: `${url}${state.document1}`, name: 'document1' }),
        state.document2 && files.push({ url: `${url}${state.document2}`, name: 'document2' }),
        files.forEach((file) => downloadFile(file.url, file.name)));
    } catch (error) {
      enqueueSnackbar(error.message || 'Error while Downloading Candidate Documents.', {
        variant: 'error',
      });
    }
  };

  const downloadFile = async (url, filename) => {
    try {
      const response = await fetch(url, { mode: 'cors' });
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      enqueueSnackbar(err.message || 'Error while Downloading Document', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <Stack direction="column" sx={{ height: 1 }}>
      <TabContext value={value}>
        <Stack sx={{ alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Tabs
            value={value}
            onChange={handleChange}
            sx={(theme) => ({
              p: 0.5,
              borderRadius: 1.5,
              flexShrink: 0,
              bgcolor: 'background.elevation1',
              [`& .${tabsClasses.list}`]: {
                gap: 0,
              },
              [`& .${tabsClasses.indicator}`]: {
                height: 1,
                bgcolor: cssVarRgba(theme.vars.palette.primary.mainChannel, 0.15),
                borderRadius: 1,
              },
              [`& .${tabClasses.root}`]: {
                color: 'text.primary',
                fontWeight: 600,
                textTransform: 'none',
                [`&.${tabClasses.selected}`]: {
                  color: 'primary.dark',
                },
              },
            })}
          >
            <Tab label="Resume" value="resume" disableRipple />
            <Tab label="Aadhar Card" value="aadharCard" disableRipple />
            <Tab label="Degree Certificate" value="degreeCertificate" disableRipple />
            {state.document1 && (
              <Tab
                label="Document1"
                value="document1"
                disableRipple
                disabled={Boolean(!state.document1)}
              />
            )}
            {state.document2 && (
              <Tab
                label="Document2"
                value="document2"
                disableRipple
                disabled={Boolean(!state.document2)}
              />
            )}
          </Tabs>

          <Button variant="text" color="neutral" onClick={handleClick}>
            Download All
          </Button>
        </Stack>

        <Box sx={{ flex: 1, borderRadius: 2, overflow: 'hidden' }}>
          {/* Aadhar */}
          <TabPanel value="resume" sx={{ p: 0 }}>
            <FilePreview src={`${url}${state.resume}`} />
          </TabPanel>
          <TabPanel value="aadharCard" sx={{ p: 0 }}>
            <FilePreview src={`${url}${state.aadharCard}`} />
          </TabPanel>

          {/* Degree */}
          <TabPanel value="degreeCertificate" sx={{ p: 0 }}>
            <FilePreview src={`${url}${state.degreeCertificate}`} />
          </TabPanel>
          <TabPanel value="document1" sx={{ p: 0 }}>
            <FilePreview src={`${url}${state.document1}`} />
          </TabPanel>
          <TabPanel value="document2" sx={{ p: 0 }}>
            <FilePreview src={`${url}${state.document2}`} />
          </TabPanel>
        </Box>
      </TabContext>
    </Stack>
  );
};

export default CandidateDocuments;
